import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  input,
  signal,
} from '@angular/core';
import { ClipboardService } from '../../service/clipboard.service';

@Component({
  selector: 'app-copy-to-clipboard-button',
  imports: [],
  templateUrl: './copy-to-clipboard-button.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyToClipboardButtonComponent {
  private readonly clipboardService = inject(ClipboardService);
  private readonly destroyRef = inject(DestroyRef);
  private copiedTimeoutId: ReturnType<typeof setTimeout> | null = null;

  readonly text = input.required<string>();
  readonly ariaLabel = input.required<string>();
  readonly copiedAriaLabel = input.required<string>();
  readonly title = input('Copia');
  readonly copiedTitle = input('Copiata');
  readonly copied = signal(false);

  constructor() {
    this.destroyRef.onDestroy(() => {
      if (this.copiedTimeoutId) {
        clearTimeout(this.copiedTimeoutId);
      }
    });
  }

  async copy(): Promise<void> {
    const copied = await this.clipboardService.copyText(this.text());
    if (!copied) {
      return;
    }

    this.copied.set(true);

    if (this.copiedTimeoutId) {
      clearTimeout(this.copiedTimeoutId);
    }

    this.copiedTimeoutId = setTimeout(() => {
      this.copied.set(false);
      this.copiedTimeoutId = null;
    }, 1800);
  }
}
